export default __webpack_public_path__ + "static/media/network-receive.45eb46be.png";